module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isPc ? 'scan' : ''
  }, [_c('img', {
    staticClass: "scan-help",
    style: ({
      marginRight: (_vm.scanHelpShow ? '0' : '-140px'),
      opacity: (_vm.scanHelpShow ? '1' : '0')
    }),
    attrs: {
      "src": require("../../assets/images/scan_help.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "scan-content",
    style: ({
      marginLeft: (_vm.scanHelpShow ? '0' : '140px')
    })
  }, [_c('IconSwitch', {
    attrs: {
      "type": 'account'
    }
  }), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "margin-top": "0"
    }
  }), _vm._v(" "), _c('el-collapse-transition', [(_vm.errorShow && _vm.$route.query.showTip) ? _c('Error', {
    attrs: {
      "type": 'tip',
      "msg": _vm.errorMsg
    },
    on: {
      "closeErrorTip": _vm.closeErrorTip
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('Qrcode'), _vm._v(" "), _c('Foot', {
    staticStyle: {
      "margin-bottom": "45px"
    },
    attrs: {
      "type": 'Scan the QR code to sign in'
    },
    on: {
      "scanHelp": _vm.scanHelp
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-562536bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/new-login-2018/login/Scan.vue
// module id = 725
// module chunks = 1